const referralUrlParams = new URLSearchParams(window.location.search);
const referralCode = referralUrlParams.get("r");

// eslint-disable-next-line no-undef
if (referralCode) {
  let domain_parts = window.location.hostname.split(".");
  document.cookie = `referral_code=${referralCode}; domain=.discourse.${
    domain_parts[domain_parts.length - 1]
  }; path=/; max-age=${24 * 60 * 60}; SameSite=Strict; Secure`;

  // Plausible conversion event tracking is defined globally in <head/>
  // eslint-disable-next-line no-undef
  plausible("Referral Marketing Referral", {
    props: { referralCode },
  });
}
